import { createSlice } from '@reduxjs/toolkit';

const userAvatars = createSlice({
  name: 'form',
  initialState: [],
  reducers: {
    setUserAvatars: (_, action) => action.payload,
  },
});

export const { setUserAvatars } = userAvatars.actions;
export const userAvatarsReducer = userAvatars.reducer;
